import Hosts from '../../../Hosts';


const object_type = 'estancia/config'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`

const base_endpoint = '/estancia_config'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    //list: `${base_endpoint}_list`,
    //view: `${base_endpoint}_view`,
    view: `${base_endpoint}`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        name: '',
        description: '',
        text: '',
        pistas: [],
        meios: [],
        meteo: {
            min: '',
            max: '',
            snow: '',
        },
        date: '',
        language: []
    }
}

export {
    endpoints,
    object_type,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}